import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { Button, Grid, Menu, TextField, Typography } from '@mui/material';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { textInput } from "../../../assets/icons";
import { useDispatch } from 'react-redux';
import { addWordRequest } from '@redux/Language/actions';
export interface IModalAddWordProps {
  anchorElAdd: HTMLElement | null;
  openAdd: boolean;
  handleClose: () => void;
}

const schema = yup.object({
  name: yup.string().required("Vui lòng nhập path mới"),
  id: yup.string().required("Vui lòng nhập default"),
});

export default function ModalAddWord (props: IModalAddWordProps) {
  const dispatch = useDispatch()
  const { anchorElAdd, openAdd, handleClose } = props;
  const {
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [path, setPath]= React.useState<String>("");
  const [defaultContent, setDefaultContent]= React.useState<String>("");
  // const message = useSelector((state: AppState) => state.toTranslate.message)

  const onSubmit = async(data: any) => {
    if(path !=="" && defaultContent !==""){
      dispatch(addWordRequest({path:path ,default: defaultContent}))
    }
    handleCloseModal()
  };
  
  const handleCloseModal = () => {
    handleClose()
  }

  return (
    <Menu
      id="add-menu"
      anchorEl={anchorElAdd}
      open={openAdd}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'add-button',
      }}
      sx={{ mt: 3, mr: 2 }}
    >
      <form id="my-form">
        <Grid
          container
          alignItems={"center"}
          sx={{ p: 2, width: '100%', marginTop: 2, maxWidth: '275px' }}
        >
          <Grid item lg={12} container alignItems={'center'} justifyContent={'center'}>
            <Typography variant='h6' component={'h2'} sx={{ fontWeight: '400' }}>Thêm từ mới</Typography>
          </Grid>
          <Grid item lg={12} container alignItems={'center'} wrap={'nowrap'} sx={{ mt: 3 }}>
            <img src={textInput} alt="" style={{width:"30px"}}/>
            <div style={{ width: "95%" }}>
              <Controller
                name="title"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    fullWidth
                    variant="standard"
                    label="Nhập path"
                    color="info"
                    value={path}
                    error={!!errors?.title}
                    // helperText={errors?.title?.message}
                    onChange={(e) => {
                      // setValue("slug", toASCII(e.target.value));
                      onChange(setPath(e.target.value));
                    }}
                    sx={{ ml: 2, width: 'unset' }}
                  />
                )}
              />
            </div>
          </Grid>
          <Grid item lg={12} container alignItems={'center'} wrap={'nowrap'} sx={{ mt: 2 }} >
            <img src={textInput} alt="" style={{width:"30px"}}/>
            <div style={{ width: "95%" }}>
              <Controller
                name="title"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    fullWidth
                    variant="standard"
                    label="Nhập default"
                    color="info"
                    value={defaultContent}
                    error={!!errors?.title}
                    // helperText={errors?.title?.message}
                    onChange={(e) => {
                      // setValue("slug", toASCII(e.target.value));
                      onChange(setDefaultContent(e.target.value));
                    }}
                    sx={{ ml: 2, width: 'unset' }}
                  />
                )}
              />
            </div>
          </Grid>
          <Grid item lg={12} container alignItems={'center'} justifyContent={'flex-end'} wrap={'nowrap'} sx={{ mt: 5 }}>
            <Button variant='contained' color='secondary' sx={{ mr: 1 }} onClick={handleClose}>Hủy</Button>
            <Button variant='contained' color='primary' onClick={onSubmit}>Lưu</Button>
          </Grid>
        </Grid>
      </form>
    </Menu>
  );
}
